import { Injectable, signal } from '@angular/core';
import { SuiteGroupClusterModel } from '../shared/models/suite-group-cluster.model';

@Injectable({ providedIn: 'root' })
export class SuiteGroupClusterStore {
  private readonly _suiteGroupClusters = signal<SuiteGroupClusterModel[]>([]);

  readonly suiteGroupClusters = this._suiteGroupClusters.asReadonly();

  setSuiteGroupClusters(suiteGroupClusters: SuiteGroupClusterModel[]) {
    this._suiteGroupClusters.set([...suiteGroupClusters]);
  }

  addSuiteGroupCluster(suiteGroupCluster: SuiteGroupClusterModel) {
    this._suiteGroupClusters.update((clusters) => [...clusters, suiteGroupCluster]);
  }

  updateSuiteGroupCluster(updated: SuiteGroupClusterModel) {
    this._suiteGroupClusters.update((clusters) =>
      clusters.map((c) => (c.id === updated.id ? updated : c))
    );
  }

  removeSuiteGroupCluster(id: Guid) {
    this._suiteGroupClusters.update((clusters) => clusters.filter((c) => c.id !== id));
  }
}
